import firebase from 'firebase';

const config = {
  apiKey: "AIzaSyA19PNwCMVV4_GdTC8Kjf1KUPMmd_4rV54",
  authDomain: "fledgling-10da4.firebaseapp.com",
  databaseURL: "https://fledgling-10da4.firebaseio.com",
  projectId: "fledgling-10da4",
  storageBucket: "fledgling-10da4.appspot.com",
  messagingSenderId: "332861268655",
  appId: "1:332861268655:web:03bd32fc657d3ed9806a5a"
};
firebase.initializeApp(config);